// FETCH LESSONS
export const FETCH_LESSONS_REQUEST = "FETCH_LESSONS_REQUEST";
export const FETCH_LESSONS_SUCCESS = "FETCH_LESSONS_SUCCESS";
export const FETCH_LESSONS_FAILURE = "FETCH_LESSONS_FAILURE";

// ADD LESSON
export const ADD_LESSON_REQUEST = "ADD_LESSON_REQUEST";
export const ADD_LESSON_SUCCESS = "ADD_LESSON_SUCCESS";
export const ADD_LESSON_FAILURE = "ADD_LESSON_FAILURE";

// UPDATE LESSON
export const UPDATE_LESSON_REQUEST = "UPDATE_LESSON_REQUEST";
export const UPDATE_LESSON_SUCCESS = "UPDATE_LESSON_SUCCESS";
export const UPDATE_LESSON_FAILURE = "UPDATE_LESSON_FAILURE";

// DELETE LESSON
export const DELETE_LESSON_REQUEST = "DELETE_LESSON_REQUEST";
export const DELETE_LESSON_SUCCESS = "DELETE_LESSON_SUCCESS";
export const DELETE_LESSON_FAILURE = "DELETE_LESSON_FAILURE";
